/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-27 15:27:59
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2024-12-13 17:26:55
 * @FilePath: \qcloud-web-pc-4.0\src\components\page-header\lang\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const page_header = {
  product: 'Products',
  solution: 'Solutions',
  learn: 'Learning',
  dev: 'Development',
  contest: 'Competition',
  about: 'About',
  chemiq: 'Biochemistry',
  finance: 'Quantum Finance',
  educate: 'Education',
  ai: 'AI',
  bigData:'Big Data',
  power:'Power Industry',
  security: 'Information Security',
  engineering: 'Engineering Design',
  about_ori: 'About Us',
  union: 'Industry Alliance',
  newslist: 'News',
  join: 'Join Us',
  workbench: 'Workbench',
  login_register: 'Log in/Register',
  app_program: 'Quantum computing programming toolkits',
  app_learn: 'Quantum machine learning toolkits',
  publish_platform: 'Platform For Releasing Quantum Computing Application',
  dev_publish: 'Platform for developing and releasing quantum application',
  contest_form: 'Competition',
  contest_platform: 'Platform for quantum computing developers competition ',
  community: 'Developer Community',
  learn_community: 'Community for quantum computing learning and sharing',
  qhCloud: 'Hybrid Quantum',
  profession: 'Industry Solutions',
  system: 'System Solutions',
  chip: 'Superconducting Quantum Chip Test  System Solution',
  temperature: 'Room Temperature Measure-control Integrated Solution',
  computerServies: 'Computing Service',
  qvmText: 'Graphical Programming',
  calculTask: 'Calculation Task',
  applyTask: 'Application Center',
  ideText: 'Cloud IDE',
  accountCenter: 'Account Center',
  officialWebsite: 'Official Website',
  originQCommunity: 'OriginQ Community',
  joinUs: 'Join Us',
  language: 'Language',
  logOut: 'Log Out',
  noData: 'No Data',
  noMessage: 'No message',
  more: 'More',
  messageCenter: 'Message Center',
  expenseCenter: 'Billing Center',
  accessMag: 'Access Management',
  computingResource: '算力资源',
  qApp: 'Apps',
  learnWeb: 'Learning',
  paperAward: 'Paper Award',
  service: '服务',
  service_quantum:'量子计算服务',
  service_lh:'融合计算服务',
  service_special:'专用量子云平台',
  tools:'编程工具',
  Qpanda:'QPanda',
  VQNet:'VQNet',
  pqypanda:'pyqpanda-algorithm',
  qrunes:'QRunes',
  qurator: 'Qurator',
  learnSource:'学习资源',
  documentShow:'Documentation',
  website: '官方网站',
  home:'Home',
};
export default page_header;
